// extracted by mini-css-extract-plugin
export default {"container":"tries_container__1Jrj7","choice":"tries_choice__K7x1G","rightAnswer":"tries_rightAnswer__Li50l","choiceEmpty":"tries_choiceEmpty__1XlbQ"};